/*eslint-disable*/
export default {
    map: require('../en/modules/map.json'),
    user: require('../en/modules/user.json'),
    miles: require('../en/modules/miles.json'),
    points: require('../en/modules/points.json'),
    common: require('../es/modules/common.json'),
    errors: require('../en/modules/errors.json'),
    olympiads: require('../en/modules/olympiads.json'),
    timetable: require('../en/modules/timetable.json'),
    historyTable: require('../en/modules/historyTable.json'),
    conversations: require('../en/modules/conversations.json'),
    profiles: require('../es/modules/profiles.json'),
    dashboard: require('../es/modules/dashboard.json'),
    timeMeasurement: require('../en/modules/timeMeasurement.json'),
    elements: require('../en/modules/elements.json'),
    declination: require('../es/modules/declination.json'),
    progress: require('../en/modules/progress.json'),
    fleshCardsPreview: require('../en/modules/fleshCardsPreview.json'),
    mapModal: require('../en/modules/mapModal.json'),
    trainer: require('./modules/trainer.json'),
    games: require('../en/modules/games.json'),
    list: require('../es/modules/list.json'),
    fields: require('../es/modules/fields.json'),
    router: require('../es/modules/router.json'),
    grade: require('../en/modules/grade.json'),
    homework: require('../es/modules/homework.json'),
    school: require('../es/modules/school.json'),
    support: require('../en/modules/support.json'),
    auth: require('../en/modules/auth.json'),
    templates: require('../es/modules/templates.json'),
    modal: require('../en/modules/modal.json'),
    course: require('../es/modules/course.json'),
    couples: require('../en/modules/couples.json'),
    mapConversations: require('../en/modules/mapConversations.json'),
    detective: require('../en/modules/detective.json'),
    detectiveModal: require('../en/modules/detectiveModal.json'),
    billing: require('../en/modules/billing.json'),
    presentations: require('../es/modules/presentations.json'),
    battle: require('../en/modules/battle.json'),
    achievements: require('../en/modules/achievements.json')
}
